"use client";

import { createContext, type ReactNode, useContext } from "react";

/**
 * Supplies a per-organization Mapbox style URL to every map in the tree, so an
 * app can set it once at boot instead of threading a prop through each of the
 * many map call sites. `InteractiveMap` and `StaticMap` read this as their
 * default; an explicit `mapStyleUrl` prop still wins for one-off cases.
 *
 * Null/absent means "use the built-in style for the selected map type", which
 * is the behavior for every organization that has not set one.
 */
const MapStyleContext = createContext<string | null>(null);

export function MapStyleProvider({ mapStyleUrl, children }: { mapStyleUrl?: string | null; children: ReactNode }) {
  return <MapStyleContext.Provider value={mapStyleUrl ?? null}>{children}</MapStyleContext.Provider>;
}

/** The organization-level style override, or null when none is configured. */
export function useMapStyleOverride(): string | null {
  return useContext(MapStyleContext);
}
